import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const utmValuesSlice = createSlice({
    name: 'utmValues',
    initialState,
    reducers: {
        setUtmValues(state, action) {
            return action.payload;
        },
        removeUtmValues(state) {
            return initialState;
        },
    },
});

export const { setUtmValues, removeUtmValues } = utmValuesSlice.actions;
export default utmValuesSlice.reducer;